import type { ActionTree } from 'vuex';
import { ESigningAction, signingNamespace } from '@signing-page/signing/store/signing.constants';
import {
  mutationSetIds,
  mutationSetPreviewMode,
  mutationSetPreviewExpired,
  mutationSetPusherConnected,
} from '@signing-page/store/mutations';
import type { IRootState } from '@signing-page/store/store';

export const actionSetIds = 'setIds';
export const actionSetPreviewMode = 'setPreviewMode';
export const actionSetPreviewExpired = 'setPreviewExpired';
export const actionSetPusherConnected = 'setPusherConnected';

export const actions: ActionTree<IRootState, IRootState> = {
  [actionSetIds](
    { dispatch, commit, state },
    payload: {
      signingPageId: string;
      recipientId?: string;
      authId: string;
      userId?: string;
      videoReminderId?: string;
    }
  ) {
    if (payload.recipientId !== state.recipientId) {
      dispatch(`${signingNamespace}/${ESigningAction.ResetBankId}`);
    }
    if (payload.userId) {
      dispatch(actionSetPreviewMode, true);
    }
    commit(mutationSetIds, payload);
  },
  [actionSetPreviewMode]({ commit }, isPreview: boolean) {
    commit(mutationSetPreviewMode, isPreview);
  },
  [actionSetPreviewExpired]({ commit }, expired: boolean) {
    commit(mutationSetPreviewExpired, expired);
  },
  [actionSetPusherConnected]({ commit }, connected: boolean) {
    commit(mutationSetPusherConnected, connected);
  },
};
